export const environment = {
  production: true,
  apiBaseUrl: '/api-host',
  storagePrefix: 'completeme.',
};
